var helpers = {};

helpers.formatNumber = function (sanitizedValue) {
  let formatted = "";
  for (let i = 0; i < sanitizedValue.length; i++) {
    if (i === 2 || i === 5 || i === 8) {
      formatted += `-${sanitizedValue[i]}`;
    } else {
      formatted += sanitizedValue[i];
    }
  }
  return formatted;
};

// example: (123)-123-1234
helpers.formatUSPhoneNumber = function (phone) {
  // Remove +1 if present at the start
  const sanitized = phone.replace(/^\+1/, "").replace(/\D/g, "");

  // Format as (123)-123-1234
  if (sanitized.length === 10) {
    return `(${sanitized.slice(0, 3)})-${sanitized.slice(
      3,
      6
    )}-${sanitized.slice(6)}`;
  }

  return phone; // Return original if not 10 digits
};

helpers.formatTaxId = function (sanitizedValue) {
  let formatted = "";
  for (let i = 0; i < sanitizedValue.length; i++) {
    if (i === 2) {
      formatted += `-${sanitizedValue[i]}`;
    } else {
      formatted += sanitizedValue[i];
    }
  }
  return formatted;
};

helpers.formatSSN = function (sanitizedValue) {
  let formatted = "";
  for (let i = 0; i < sanitizedValue.length; i++) {
    if (i === 3 || i === 5) {
      formatted += `-${sanitizedValue[i]}`;
    } else {
      formatted += sanitizedValue[i];
    }
  }
  return formatted;
};

// helpers.extractAddressComponents = function (addressString) {
//     if (!addressString || typeof addressString !== 'string') {
//         return false;
//     }
    
//     const parts = addressString.split(",").map(p => p.trim());
  
//     // Return false if not enough parts to extract city, state+zip, and country
//     if (parts.length < 3) return false;

//     // Extract country from the last part
//     const country = parts[parts.length - 1];
  
//     // Extract zip and state from second last part with more flexible regex
//     const stateZipMatch = parts[parts.length - 2].match(/^\s*([A-Z]{2})\s+(\d{5}(?:-\d{4})?)\s*$/i);
//     if (!stateZipMatch) return false;
  
//     const state = stateZipMatch[1].toUpperCase();
//     const zipCode = stateZipMatch[2];
  
//     // City is before state+zip
//     const city = parts[parts.length - 3];
  
//     // Handle street parsing
//     const streetParts = parts.slice(0, parts.length - 3);
//     let houseNumber = "";
//     let streetName = "";
  
//     // Try to detect house number in any street part
//     for (let part of streetParts) {
//       const houseAndStreetMatch = part.match(/^(\d+)\s+(.*)$/);
//       if (houseAndStreetMatch) {
//         houseNumber = houseAndStreetMatch[1];
//         streetName = houseAndStreetMatch[2];
//         break;
//       }
//     }
  
//     // If no house number match found, assume last part of street is just name
//     if (!streetName && streetParts.length > 0) {
//       streetName = streetParts[streetParts.length - 1];
//     }

//     // If still empty (e.g., only city-state-country provided), set empty string
//     if (!streetName) {
//       streetName = "";
//     }
  
//     // Safe parseInt with fallback to null for house_number
//     const parsedHouseNumber = houseNumber ? parseInt(houseNumber, 10) : null;
    
//     const addressComponents = {
//       house_number: !isNaN(parsedHouseNumber) ? parsedHouseNumber : null,
//       street_name: streetName,
//       city: city,
//       state: state,
//       zip_code: zipCode,
//       country: country
//     };
  
//     return addressComponents;
// };

// PD-22: `unitNumber` is a manually-typed apartment/suite/unit value — it
// never comes from Google's Places autocomplete `components`, so it's a
// separate argument merged straight into the returned payload rather than
// something this function tries to derive.
helpers.extractAddressComponents = function (components, config = {}, unitNumber = "") {
  const get = (type, format = "long") => {
    const found = components.find((comp) => comp.types.includes(type));
    return found ? found[`${format}Text`] : "";
  };

  const postalCode = get("postal_code", config.postalCode || "long");
  const postalCodeSuffix = get(
    "postal_code_suffix",
    config.postalCodeSuffix || "long"
  );
  const zip_code = postalCodeSuffix
    ? `${postalCode}-${postalCodeSuffix}`
    : postalCode;

  // City fallback order (US-only — autocomplete is restricted to "us"), most
  // specific place name first, county only as a last resort:
  //   locality      → a real city/town (most addresses)
  //   postal_town   → UK-style postal town; not used in the US today, kept
  //                   in case the region restriction is ever widened
  //   sublocality  → NYC boroughs, which often have no locality (Brooklyn,
  //                   not "Kings County")
  //   admin_level_3 → townships (NJ, PA, MI, New England)
  //   neighborhood  → unincorporated places with no city (e.g. "2400 Aviation
  //                   Dr, DFW Airport, TX 75261" → "DFW Airport")
  //   admin_level_2 → the county, only when nothing more specific exists
  const city =
    get("locality", config.city || "long") ||
    get("postal_town", config.city || "long") ||
    get("sublocality", config.city || "long") ||
    get("administrative_area_level_3", config.city || "long") ||
    get("neighborhood", config.city || "long") ||
    get("administrative_area_level_2", config.city || "long");

  const state = get("administrative_area_level_1", config.state || "long");
  const country = get("country", config.country || "long");

  // ❌ Return false if required components are missing
  if (!city || !zip_code || !state || !country) {
    return false;
  }

  const addressComponents = {
    house_number:
      parseInt(get("street_number", config.streetNumber || "long")) || null,
    street_name: get("route", config.route || "long"),
    unit_number: unitNumber || "",
    city,
    state,
    zip_code,
    country,
  };

  return addressComponents;
};

helpers.dataURItoBlob = function (dataURI) {
  const byteString = atob(dataURI.split(",")[1]);
  const mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);

  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  return new Blob([ab], { type: mimeString });
};

// Backend timestamps are ISO 8601 strings that carry a UTC offset, e.g.
// "2026-10-20T15:54:10-07:00", so `new Date()` resolves the exact instant and
// the display uses the viewer's own timezone. Returns "" for a missing/invalid value.
helpers.formatDateTime = function (isoString) {
  if (!isoString) return "";
  const date = new Date(isoString);
  if (isNaN(date.getTime())) return "";
  return date.toLocaleString("en-US");
};

// Same instant, pinned to Pacific time with its label (PDT/PST). For stored
// documents such as the application PDF, which must read the same for everyone.
helpers.formatDateTimePacific = function (isoString) {
  if (!isoString) return "";
  const date = new Date(isoString);
  if (isNaN(date.getTime())) return "";
  return date.toLocaleString("en-US", {
    timeZone: "America/Los_Angeles",
    timeZoneName: "short",
  });
};

helpers.parseVehicleData = function (data) {
  const parts = data.split("-");
  const year = parts[0];
  const model = parts.pop(); // last element
  const make = parts.slice(1).join("-"); // everything in between
  return { year, make, model };
}

// Turns a Django REST Framework validation error response
// ({ field_name: ["message", ...], ... }) into something a step/review form
// can actually show. `fieldMap` maps backend snake_case keys to this form's
// own local error-state keys (e.g. { personal_co_applicant_date_of_birth:
// "coApplicantDob" }) so the message can render under the specific field
// instead of only as one generic banner at the bottom of the form.
// Returns null when `data` isn't a plain field-error object (network error,
// non-JSON error page, the app's own custom "{ Error: [...] }" shape used by
// the final-submit endpoint, etc.) so the caller can fall back accordingly.
helpers.parseServerFieldErrors = function (data, fieldMap = {}) {
  if (!data || typeof data !== "object" || Array.isArray(data)) return null;
  const fieldErrors = {};
  const messages = [];
  Object.entries(data).forEach(([key, value]) => {
    const message = Array.isArray(value) ? value.join(" ") : String(value);
    const localKey = fieldMap[key];
    if (localKey) fieldErrors[localKey] = message;
    messages.push(message);
  });
  if (messages.length === 0) return null;
  return { fieldErrors, message: messages.join(" ") };
};

// Equipment Year/Make/Model rules, shared by StepEquipment.js and
// StepReview.js's Equipment edit card. All three fields are optional — an
// empty value is always valid; these only check what was actually entered.
// Each returns the error message, or "" when the value is fine.
const EQUIPMENT_MIN_YEAR = 1900;
const EQUIPMENT_MIN_TEXT_LENGTH = 2;

helpers.getEquipmentYearError = function (value) {
  // Not trimmed: the year is saved exactly as typed, so " 2021" must fail.
  const year = String(value ?? "");
  if (!year) return "";
  if (!/^\d{4}$/.test(year)) return "Enter a 4-digit year (e.g., 2020), or leave blank.";
  // Next year from today's date, not a fixed number, so this never needs
  // bumping — dealers list next model-year equipment ahead of time.
  const maxYear = new Date().getFullYear() + 1;
  const yearNum = parseInt(year, 10);
  if (yearNum < EQUIPMENT_MIN_YEAR || yearNum > maxYear) {
    return `Year must be between ${EQUIPMENT_MIN_YEAR} and ${maxYear}`;
  }
  return "";
};

// Make and Model accept any characters (letters, numbers, spaces, hyphens,
// slashes — real listings like "CASCADIA 6X4 T/A" use them); only a
// minimum length is enforced.
helpers.getEquipmentTextError = function (label, value) {
  const text = String(value ?? "").trim();
  if (!text) return "";
  if (text.length < EQUIPMENT_MIN_TEXT_LENGTH) {
    return `${label} must be at least ${EQUIPMENT_MIN_TEXT_LENGTH} characters`;
  }
  return "";
};

module.exports = helpers;
